import { render, staticRenderFns } from "./SyncDatabaseSizeDialog.vue?vue&type=template&id=05583c2a&"
import script from "./SyncDatabaseSizeDialog.vue?vue&type=script&lang=ts&"
export * from "./SyncDatabaseSizeDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports